import React from 'react'
import { 
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CImg,
  CInput,
  CRow,
  CLabel,
  CModal,
  CForm,
  CCol,
  CFormGroup,
  CButton,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import axios from '../axios/axios';
class TheHeaderDropdown extends React.Component {

  toggle() {
    this.setState({ info: !this.state.info })
    // console.log(this.state.modal);

  }
  logout() {
    localStorage.clear()
  
    window.location.href = "/login"
  }
  componentDidMount() {
    this.setState({ login_name: localStorage.getItem('user_name') });
    this.setState({ password: localStorage.getItem('password') });
    console.log(localStorage.getItem('imgg') )
    // this.download_file(localStorage.getItem('fk_emp'),localStorage.getItem('imgg'));
  }
  constructor(props) {
    super(props);
    this.state = {
      login_name: ''
      ,info:false
      , password: 'admin'
      , errortxt: ''
      , imgg: ''
      , user_type: ''
      , user_name: ''
    }
    this.toggle = this.toggle.bind(this);
    this.logout = this.logout.bind(this);
   
  }
     download_file (codee,filee_path){


    // if(filee_path!=null)
    // {
    //       var linkk = '/misc/rtn_img/' + codee
    //  ;
    //     let options = {
      
    //       onDownloadProgress:  (progressEvent)=> {
           
    //        console.log(progressEvent);
    //         // Function fires when there is download progress
    //         // const output = document.getElementById('output'); 
    //         // output.innerText = Math.floor(progressEvent.loaded / progressEvent.total);
    //         // Outputs progress to page (1 = complete)
    //         },
    //       responseType: 'blob',
         
    //       headers: {
    //         'Access-Control-Allow-Origin': '*',
    //         'Content-Type': 'application/json',
    //       },
          
            
          
    //     }
        
    //     axios.get(linkk,options
    //     )
    //     .then((response)=>{
          
    //          const url = window.URL.createObjectURL(new Blob([response.data]));
    //          let data = new Blob([response.data]);
    //          console.log(data);
    //            const {size, type} = data
    //            let metadata = {
    //              type: type
    //            };
             
    // var tpee= "";
    // if(filee_path!="")
    // if(filee_path.includes('.jpg')  ||  filee_path.includes('.jpeg') )
    // tpee =".jpg";
    
    // if(filee_path!="")
    // if(filee_path.includes('.png') )
    // tpee =".png";
    
    //            let file = new File([data], filee_path, metadata);
    //            this.setState({imgg: url,
    //             Aimgg: (file),
    //           });
    //          // seturll(url);
           
    
       
    //              }).catch((error)=>{
    //          //print(error.message);
       
    //              });
    //             }
      }
  user_value() {

    return (
      <div>     {this.state.password}     </div>
      );
  }
  render() {
    return (
      <CDropdown
        inNav
        className="c-header-nav-items mx-2"
        direction="down"
        
      >
        <CDropdownToggle className="c-header-nav-link" caret={false}  >
          <CLabel style={{ color: 'black', fontWeight: 'bold',paddingRight:'20px'  }}>   {this.state.login_name}</CLabel>
          <div className="c-avatar">

            <CImg
              src={(this.state.imgg=='' || this.state.imgg==null )?'avatars/avatar2.png': this.state.imgg}
              className="c-avatar-img"
              alt="admin@bootstrapmaster.com"
            />
          </div>
        </CDropdownToggle>
        <CDropdownMenu className="pt-0" placement="bottom-end">

       

          <CDropdownItem onClick={this.toggle} >
            <CIcon name="cil-user" className="mfe-2" />Profile
        </CDropdownItem>
         

          <CDropdownItem divider />
          <CDropdownItem onClick={this.logout} >
            <CIcon name="cil-user" className="mfe-2" />
            Logout
        </CDropdownItem>
        </CDropdownMenu>

        <CModal
          show={this.state.info}
          onClose={this.toggle}
          color="info"
          size="xl"
        >
          <CModalHeader closeButton>
            <CModalTitle>Profile Information</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <CForm action="" method="post" encType="multipart/form-data" className="form-horizontal">
              <CRow>
              <CCol md="6">

                <CCol md="12">
                <CFormGroup row>

                  <CLabel htmlFor="text-input">User Name</CLabel>

               

                  <CInput name="name" readOnly value={this.state.login_name} required className="form-control input-name"></CInput>    
                  

                </CFormGroup>
                </CCol>

              </CCol>
              <CCol md="6">
               
            <CImg
              src={(this.state.imgg=='' || this.state.imgg==null )?'avatars/avatar2.png': this.state.imgg}
              className="c-avatar-img"
              width={50}
              height={50}
              alt="admin@bootstrapmaster.com"
            />
                </CCol>
                </CRow>
            </CForm>
          </CModalBody>
          <CModalFooter>

            <CButton color="info" onClick={this.logout}>Logout</CButton>{' '}
            <CButton color="secondary" onClick={this.toggle}>Cancel</CButton>
          </CModalFooter>
        </CModal>
      </CDropdown>
    );
  }
}
export default TheHeaderDropdown
